import styled from 'styled-components';
import { 
    BaseContainer, 
    BaseTitle, 
    BaseIconContainer, 
    BaseButtonContainer, 
    BaseMessageContainer, 
    BaseMessage 
} from '../masterBase/styles';

export const SuccessMaster = styled.div`
  background: rgb(0 255 0 / 50%);
`;

// Using base components with success variant
export const Container = BaseContainer;
export const Title = BaseTitle;
export const IconContainer = BaseIconContainer;
export const MessageContainer = BaseMessageContainer;
export const Message = BaseMessage;
export const ButtonContainer = BaseButtonContainer;
